import { type PropsWithChildren, createContext, useContext } from 'react';

export interface Props {
  stepNext: (onLastStep?: () => Promise<unknown>) => Promise<unknown>;
  stepTo: (step: string) => unknown;
  currentStep: string;
}

const Context = createContext<Props>({
  stepNext: () => Promise.resolve(null),
  stepTo: (_step: string) => null,
  currentStep: '',
});

export const StepperProvider = ({ children, ...props }: PropsWithChildren<Props>) => {
  return <Context.Provider value={props}>{children}</Context.Provider>;
};

export const useStepper = () => useContext(Context);
